export default "__VITE_ASSET__Cg3UZ3OS__"